import { useCallback, useMemo } from 'react';

import { useDefaultEvents, useGrid } from '@Components/Grid';

export default function useEvents() {
  const { store: { saveBulk }, handleRefresh } = useGrid()
  const { handleDeleteEntry, handleUpdateEntry } = useDefaultEvents()

  const handleSaveBulk = useCallback(async (payload, params) => {
    await saveBulk(payload, params)
    await handleRefresh()
  }, [saveBulk, handleRefresh])

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
    handleSaveBulk,
  }), [handleUpdateEntry, handleDeleteEntry, handleSaveBulk])
}
